import { render, staticRenderFns } from "./accountdialog.vue?vue&type=template&id=07d0c33c&"
import script from "./accountdialog.vue?vue&type=script&lang=js&"
export * from "./accountdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d0c33c')) {
      api.createRecord('07d0c33c', component.options)
    } else {
      api.reload('07d0c33c', component.options)
    }
    module.hot.accept("./accountdialog.vue?vue&type=template&id=07d0c33c&", function () {
      api.rerender('07d0c33c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/accountdialog.vue"
export default component.exports